// extracted by mini-css-extract-plugin
module.exports = {"element":"embed_element__1rhDT","inner":"embed_inner__3vpIx"};